export default "__VITE_ASSET__V68llE64__"